export default function Footer() {
  return (
    <footer className="bg-stone-100 py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-8">
          <img
            src="https://public.readdy.ai/ai/img_res/a6415dae-d67c-469c-bfb4-25a94ed7f239.png"
            alt="William and Mary Wedding Logo"
            className="h-12 sm:h-16 w-auto object-contain mx-auto mb-6"
          />
          <h3 className="font-serif text-2xl sm:text-3xl text-gray-900 mb-2">William & Mary</h3>
          <p className="text-gray-600 text-xs sm:text-sm font-light tracking-widest">JUNE 18TH, 2026</p>
        </div>

        <div className="flex flex-wrap justify-center gap-4 sm:gap-6 mb-8 px-4">
          <a
            href="#home"
            className="text-gray-600 text-xs sm:text-sm font-light tracking-wide hover:text-gray-900 transition-colors cursor-pointer"
          >
            Home
          </a>
          <a
            href="#event-details"
            className="text-gray-600 text-xs sm:text-sm font-light tracking-wide hover:text-gray-900 transition-colors cursor-pointer"
          >
            Event Details
          </a>
          <a
            href="#couple-bio"
            className="text-gray-600 text-xs sm:text-sm font-light tracking-wide hover:text-gray-900 transition-colors cursor-pointer"
          >
            Our Story
          </a>
          <a
            href="#rsvp"
            className="text-gray-600 text-xs sm:text-sm font-light tracking-wide hover:text-gray-900 transition-colors cursor-pointer"
          >
            RSVP
          </a>
          <a
            href="#contact"
            className="text-gray-600 text-xs sm:text-sm font-light tracking-wide hover:text-gray-900 transition-colors cursor-pointer"
          >
            Contact
          </a>
        </div>

        <div className="border-t border-gray-300 pt-8 text-center px-4">
          <p className="text-gray-600 text-xs font-light tracking-wide">
            © 2026 William & Mary Wedding. All rights reserved. | <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="hover:text-gray-900 transition-colors cursor-pointer">Website Builder</a>
          </p>
        </div>
      </div>
    </footer>
  );
}
